import { useContext, useEffect, useState } from "react";
import AppTable from "../../components/shared-components/table/AppTable";
import { AddTicketsInput } from "./AddTickets";
import { useLazyQuery } from "@apollo/client";
import { GET_ALL_VENUE_OF_TEAM_BY_LEAGUE_ID, GET_ALL_VENUE_OF_TEAM_BY_TEAM_ID } from "./api/addTicketsQuery";
import { Button, CircularProgress } from "@mui/material";
import addTicketStyles from "./AddTickets.module.css";
import styles from "../Settings/AppVersion.module.css";
import ToasterWithMessage from "../../components/shared-components/toaster";
import stylesUser from "../Users/Users.module.css";
import { globalContext } from "../../Provider/AppProvider";

const PickVenues = ({
    setPage,
    ticketDetails,
    setTicketDetails,
    isFrom,
    page,
    search,
    setResetEvent,
    resetEvent
}: AddTicketsInput) => {
    const [teamVenues, setTeamVenues] = useState<any>([]);
    const [selected, setSelected] = useState<number[]>([]);
    const [selectedVenues, setSelectedVenues] = useState<string[]>([]);
    const [checking, setChecking] = useState<boolean>(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [columnTypes, setColumnTypes] = useState('e_date');
    const [sortType, setSortType] = useState('asc');
    const { error } = ToasterWithMessage();
    const {globalState,handleGlobalState} = useContext<any>(globalContext);
  
    const [getTeamVenueList, { loading: singleListLoading }] = useLazyQuery(GET_ALL_VENUE_OF_TEAM_BY_TEAM_ID, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            setTeamVenues({venues: data?.league_team_venues, venues_aggregate: data?.league_team_venues_aggregate});
            if(globalState.eventUpdate.updateEvent){
                const tempState = {...globalState};
                tempState.eventUpdate.updateEvent  = false
                handleGlobalState(tempState);
            }
        },
        onError: (err) => {
            console.log(err)
        }
    });
    const [getTeamVenueBylIdList, { loading: singleListLoadingl }] = useLazyQuery(GET_ALL_VENUE_OF_TEAM_BY_LEAGUE_ID, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            setTeamVenues({venues: data?.league_team_venues, venues_aggregate: data?.league_team_venues_aggregate,total_venues_of_league: data?.total_venues_of_league});
            if(globalState.eventUpdate.updateEvent){
                const tempState = {...globalState};
                tempState.eventUpdate.updateEvent  = false
                handleGlobalState(tempState);
            }
        },
        onError: (err) => {
            console.log(err)
        }
    })

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setSelected([]);
        setCurrentPage(1);
    }

    const handlePageChange = (_event: any, newPage: number) => {
        setCurrentPage(newPage);
    }

    useEffect(() => {
        if(!ticketDetails) return
        if(ticketDetails?.leagueType === "Sports"){
            getTeamVenueList({
                   variables: {
                       lt_id: ticketDetails?.homeTeamId,
                       limit: rowsPerPage,
                       offset: (currentPage - 1) * rowsPerPage,
                       // orderBy: { [columnTypes]: sortType },
                   }
               })
        }else{
            const {venueName} = ticketDetails || {}
            getTeamVenueBylIdList({variables:{l_id: ticketDetails?.leagueId ,
                            searchText: venueName ? `%${venueName}%` : '%',
                            limit: rowsPerPage,
                            offset: (currentPage - 1) * rowsPerPage,}})
        }

    }, [])

    useEffect(() => {
        if (page == 1) {
            if (ticketDetails?.leagueType === "Sports") {
                if(ticketDetails?.homeTeamId){
                    getTeamVenueList({
                        variables: {
                            lt_id: ticketDetails?.homeTeamId,
                            limit: rowsPerPage,
                            offset: (currentPage - 1) * rowsPerPage,
                            // orderBy: { [columnTypes]: sortType },
                        }
                    })
                }

            } else {
                const {venueName} = ticketDetails || {}
                if(ticketDetails?.leagueId){
                    getTeamVenueBylIdList({ variables: { l_id: ticketDetails?.leagueId ,
                                searchText: venueName ? `%${venueName}%` : '%',
                                limit: rowsPerPage,
                                offset: (currentPage - 1) * rowsPerPage,} })
                }
            }
        }
    }, [page, search]);
    useEffect(()=>{
        if(resetEvent){
            setTeamVenues([])
            setResetEvent && setResetEvent(false)
        }
    }, [resetEvent])

    useEffect(() => {
        if (globalState.eventUpdate.updateEvent) {
            if (ticketDetails?.leagueType === "Sports") {
                getTeamVenueList({
                    variables: {
                        lt_id: ticketDetails?.homeTeamId,
                        limit: rowsPerPage,
                        offset: (currentPage - 1) * rowsPerPage,
                        // orderBy: { [columnTypes]: sortType },
                    }
                })

            } else {
                const {venueName} = ticketDetails || {}
                getTeamVenueBylIdList({ variables: { l_id: ticketDetails?.leagueId,
                            searchText: venueName ? `%${venueName}%` : '%',
                            limit: rowsPerPage,
                            offset: (currentPage - 1) * rowsPerPage, } })
            }
        }
           
    }, [globalState.eventUpdate.updateEvent]);

    useEffect(() => {
        if(ticketDetails?.leagueType === "Sports"){
                getTeamVenueList({
                        variables: {
                            lt_id: ticketDetails?.homeTeamId,
                            limit: rowsPerPage,
                            offset: (currentPage - 1) * rowsPerPage,
                            // orderBy: { [columnTypes]: sortType },
                        }
                    })
        }else{
            const {venueName} = ticketDetails || {}
            getTeamVenueBylIdList({variables:{l_id: ticketDetails?.leagueId,
                            searchText: venueName ? `%${venueName}%` : '%',
                            limit: rowsPerPage,
                            offset: (currentPage - 1) * rowsPerPage, }})
        }
    }, [currentPage, rowsPerPage, sortType, columnTypes])

    const GenerateEventsHeadCells = () => {
        const id = ["ltv_name",'action','action']
        const labels = ["Venue","VenueId",'Action']
        const headCells = id.map((id, index) => ({
            id,
            label: labels[index],
        }));
        console.log("===headCells",headCells)
        return headCells;
    }

    const handleEventNext = () => {
        if (selectedVenues?.length) {
            setTicketDetails({
                ...ticketDetails,
                eventId: selectedVenues
            });
            setPage(3);
        } else {
            error('Please select any one of the events')
        }

    }

    return (
        <>
            {
                ( singleListLoading) ? <div className={stylesUser.TableCircularProgress}>
                    <CircularProgress color="primary" size={35} />
                </div> :
                    <div style={{ width: '100%' }}>
                        <AppTable
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            handlePageChange={handlePageChange}
                            setColumnTypes={setColumnTypes}
                            sortType={sortType}
                            setSortType={setSortType}
                            setSelected={setSelected}
                            setChecking={setChecking}
                            checking={checking}
                            selected={selected}
                            rowsPerPage={rowsPerPage}
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                            list={teamVenues}
                            tableTitle={"pickVenues"}
                            generateHeadCells={GenerateEventsHeadCells}
                            selectedVenues={selectedVenues}
                            setSelectedVenues={setSelectedVenues}
                            tablePurpose={isFrom}
                            isSportsLeagueTable={ticketDetails?.leagueType === "Sports"}
                        // handleDropdownChange={handleDropdownChange}
                        // selectedValues={selectedValues}
                        // setSelectedValues={setSelectedValues}
                        />
                        {
                           isFrom === "addTickets" && (teamVenues?.events?.length !== 0) && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <div className={addTicketStyles.eventBtnStyle}>
                                    <Button
                                        classes={{
                                            root: styles.separateStyleReferral
                                        }}
                                        disableRipple
                                        fullWidth
                                        type="button"
                                        onClick={handleEventNext}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>
                        }
                    </div>
            }

        </>
    )
}

export default PickVenues;
